import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import HashIcon from "assets/icons/person.svg?react";
import { useEffect, useRef, useState } from "react";
import {
  faCaretDown,
  faCaretRight,
} from "@fortawesome/free-solid-svg-icons";
import { useOnClickOutside } from "usehooks-ts";
import Placeholder from "assets/placeholder.png";
import { useTranslation } from "react-i18next";

const SidebarDossierFilterChoosePerson: FC<Props> = ({
  onChoose,
  label,
  initOpen = false,
  onClose,
  className = "",
  users,
}) => {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);

  const outsideRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    if (active) {
      setActive(false);
    }

    if (onClose && !label) {
      onClose();
    }
  });

  useEffect(() => {
    if (!initOpen) return;
    setActive(true);
  }, [initOpen]);

  return (
    <div ref={outsideRef} className={`${styles.wrapper}`}>
      <div
        onClick={() => setActive(!active)}
        className={`${styles.card} ${className}`}
      >
        <div className={styles.left}>
          <HashIcon className={styles.icon} /> {label ? label : t("common.person")}{" "}
        </div>

        <div className={styles.right}>
          {!onClose && (
            <FontAwesomeIcon icon={active ? faCaretDown : faCaretRight} />
          )}
        </div>
      </div>

      {active && (
        <div className={styles.dropdown}>
          <div className={styles.list}>
            {users.map((u) => (
              <div
                onClick={() => {
                  onChoose(u);
                  setActive(false);
                }}
                className={styles.box}
                key={u.Id}
              >
                {/* {<type.image />} */}
                <img src={Placeholder} />
                {u.Label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SidebarDossierFilterChoosePerson;
